import { useEffect } from 'react'
import {
  ChildLandingPage,
  CompleteRequestPage,
  LoadingPage,
  NotFoundPage,
  PendingPage,
  PlatformLoginPage,
} from '../pages'
import { useAuth } from '../providers/auth'
import { ConsentStatus, UserTypes } from '../types/Account'

const statusRenderer = (status: ConsentStatus) => {
  switch (status) {
    case ConsentStatus.NOT_REQUESTED:
      return <ChildLandingPage />
    case ConsentStatus.REQUEST_SENT:
      return <PendingPage />
    case ConsentStatus.APPROVED:
      return <CompleteRequestPage />
    case ConsentStatus.REVOKED:
      return <NotFoundPage />
    default:
      return <NotFoundPage />
  }
}

const UserRouter = () => {
  const { authState, logout } = useAuth()

  // if user has the wrong type of account data in state, log them out
  useEffect(() => {
    if (authState.userType && authState.userType == UserTypes.approver) {
      logout()
    } else if (
      authState.accountInfo &&
      authState.accountInfo.consent.status === ConsentStatus.REVOKED
    ) {
      logout()
    }
  }, [authState])

  return (
    <>
      {authState.isLoading ? <LoadingPage /> : null}
      {!authState.isLoading && authState.jwt == null ? <PlatformLoginPage /> : null}
      {!authState.isLoading && authState.accountInfo
        ? statusRenderer(authState.accountInfo.consent.status)
        : null}
    </>
  )
}

export default UserRouter
